import Html from "./Html.png";
import Css from "./Css.png";
import Js from "./Js.png";
import Bootstrap from "./Bootstrap.png";
import Sass from "./Sass.png";
import React from "./React.png";
import Mongodb from "./Mongodb.png";
import Express from "./Express.png";
import Node from "./Node.png";
import Graphql from "./Graphql.png";
import Laravel from "./Laravel.png";
import Mysql from "./Mysql.png";
import Php from "./Php.png";
import Github from "./Github.png";
import Heroku from "./Heroku.png";
import Figma from "./Figma.png";
import Photoshop from "./Photoshop.png";
import Filmora from "./Filmora.png";
import Autocad from "./Autocad.png";
import Sketchup from "./Sketchup.png";
import Bagisto from "./Bagisto.png";
import Typescript from "./Typescript.png";
import Mui from "./Mui.png";

const ImagesLang = {
  Html: Html,
  Css: Css,
  Js: Js,
  Bootstrap: Bootstrap,
  Sass: Sass,
  React: React,
  Mongodb: Mongodb,
  Express: Express,
  Node: Node,
  Graphql: Graphql,
  Laravel: Laravel,
  Mysql: Mysql,
  Php: Php,
  Github: Github,
  Heroku: Heroku,
  Figma: Figma,
  Photoshop: Photoshop,
  Filmora: Filmora,
  Autocad: Autocad,
  Sketchup: Sketchup,
  Bagisto: Bagisto,
  Typescript: Typescript,
  Mui: Mui,
};

export default ImagesLang;
